import { lazy, Suspense, useEffect } from 'react'
import { HashRouter, Route, Routes } from 'react-router-dom'
import { ApiSettingsType } from '../../model/model'
import { useAppDispatch, useAppSelector } from '../../store/store'
import { fetchConfig, setAPISetting } from '../../store/configSlice'
import Loading from '../Loading'
import Home from '../Home/Home'

const SelectInstructorModal = lazy(() => import('../SelectInstructorModal/SelectInstructorModal'))
const WaitingForApprovalModal = lazy(() => import('../WaitingForApprovalModal/WaitingForApprovalModal'))

const User = lazy(() => import('../User/User'))
const Belt = lazy(() => import('../Belt/Belt'))
const BeltContent = lazy(() => import('../BeltContent/BeltContent'))

type PropsType = {
  config: ApiSettingsType
}

const AppRouter = ({ config }: PropsType) => {
  const dispatch = useAppDispatch()
  const storeConfig = useAppSelector((state) => state.config)

  useEffect(() => {
    if (config) {
      dispatch(setAPISetting(config))
    }
  }, [config, dispatch])

  useEffect(() => {
    if (storeConfig.setting) {
      dispatch(fetchConfig())
    }
  }, [dispatch, storeConfig.setting])

  if (!storeConfig.init) return <Loading />

  return (
    <Suspense fallback={<Loading />}>
      {storeConfig.need_select_instructor && !storeConfig.instructor_id ? <SelectInstructorModal /> : undefined}
      {storeConfig.need_select_instructor && storeConfig.instructor_id && !storeConfig.instructor_approved ? (
        <WaitingForApprovalModal />
      ) : undefined}

      <HashRouter>
        <Routes>
          <Route path='*' element={<Home />}>
            <Route path=':activeTab/*' element={<Belt />}>
              <Route path=':activeChallenge/*' element={<BeltContent />} />
            </Route>
          </Route>
          {storeConfig.is_admin || storeConfig.is_instructor ? (
            <Route path='user/*' element={<Home />}>
              <Route path=':userID/*' element={<User />}>
                <Route path=':activeTab/*' element={<Belt />}>
                  <Route path=':activeChallenge/*' element={<BeltContent />} />
                </Route>
              </Route>
            </Route>
          ) : null}
        </Routes>
      </HashRouter>
    </Suspense>
  )
}

export default AppRouter
